import { StyledActionButton } from "@/components/shared/StyledActionButton";
import { Box, Center, Stack, Text, Title } from "@mantine/core";
import { useNavigate } from "react-router-dom";

export function ReservationChangeDeclinedPage() {
  const navigate = useNavigate();

  const handleBackToHome = () => {
    navigate("/home");
  };

  return (
    <Center h="100vh" p="lg">
      <Box maw={400} w="100%">
        <Stack gap="xl" ta="center">
          <Title order={2}>죄송합니다</Title>

          <Text size="lg" lh={1.6}>
            변경을 거절하셨습니다.
            <br />더 나은 서비스를 제공하도록 노력하겠습니다.
          </Text>

          <Center>
            <StyledActionButton size="lg" onClick={handleBackToHome} mt="xl">
              홈으로 돌아가기
            </StyledActionButton>
          </Center>
        </Stack>
      </Box>
    </Center>
  );
}
